import React from 'react';
import PolicyEmbed from '../components/PolicyEmbed';

const TermsOfService = () => {
  return (
    <PolicyEmbed 
      id="TUZScVptbEJTbVE1VEVGSVEyYzlQUT09" 
      title="Terms of Service" 
    />
  );
};

export default TermsOfService;
